module.exports = __webpack_public_path__ + "static/rose-e0167ff85140e3a29a1a32f454247e4a.png";